export default __webpack_public_path__ + "static/media/RoyalSundaram.12405931.svg";